/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  FindCertificateRequestsByCertificateIdQueryResponse,
  FindCertificateRequestsByCertificateIdQueryParams,
} from "../types/FindCertificateRequestsByCertificateId.ts"

export const findCertificateRequestsByCertificateIdQueryKey = (
  params: FindCertificateRequestsByCertificateIdQueryParams
) =>
  [
    {
      url: "/v1/certificate-request/find-certificate-requests-by-certificate-id",
    },
    ...(params ? [params] : []),
  ] as const

export type FindCertificateRequestsByCertificateIdQueryKey = ReturnType<
  typeof findCertificateRequestsByCertificateIdQueryKey
>

/**
 * @summary Find certificate requests by certificate id
 * {@link /v1/certificate-request/find-certificate-requests-by-certificate-id}
 */
export async function findCertificateRequestsByCertificateId(
  params: FindCertificateRequestsByCertificateIdQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindCertificateRequestsByCertificateIdQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/certificate-request/find-certificate-requests-by-certificate-id`,
    params,
    ...requestConfig,
  })
  return res
}

export function findCertificateRequestsByCertificateIdQueryOptions(
  params: FindCertificateRequestsByCertificateIdQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = findCertificateRequestsByCertificateIdQueryKey(params)
  return queryOptions<
    ResponseConfig<FindCertificateRequestsByCertificateIdQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindCertificateRequestsByCertificateIdQueryResponse>,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return findCertificateRequestsByCertificateId(params, config)
    },
  })
}

/**
 * @summary Find certificate requests by certificate id
 * {@link /v1/certificate-request/find-certificate-requests-by-certificate-id}
 */
export function useFindCertificateRequestsByCertificateId<
  TData = ResponseConfig<FindCertificateRequestsByCertificateIdQueryResponse>,
  TQueryData = ResponseConfig<FindCertificateRequestsByCertificateIdQueryResponse>,
  TQueryKey extends QueryKey = FindCertificateRequestsByCertificateIdQueryKey,
>(
  params: FindCertificateRequestsByCertificateIdQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindCertificateRequestsByCertificateIdQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey =
    queryOptions?.queryKey ??
    findCertificateRequestsByCertificateIdQueryKey(params)

  const query = useQuery(
    {
      ...findCertificateRequestsByCertificateIdQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
